import { observe } from "../../reactive";
import { ScreenRectangle } from "../ScreenRectangle";
import { Vector2 } from "../../math";
import { Alt1Overlay } from "./Alt1Overlay";
import { Alt1Color } from "../Alt1Color";
export class Alt1OverlayButton extends Alt1Overlay {
    constructor(area, config) {
        super();
        this.area = area;
        this.config = observe(config)
            .structuralEquality()
            .subscribe(() => this.rerender());
        this.interactivity().setBounds(area ? { type: "rectangle", area: area } : null);
    }
    renderWithBuilder(overlay) {
        if (!this.area)
            return;
        const render_as_hovered = this.interactivity().isHovered(); // || this.isDefaultHovered()
        const config = this.config.value();
        const style_a = render_as_hovered ? config.active_style : {};
        const style_b = config.style;
        const style = { ...style_b, ...style_a };
        const stroke = style.stroke;
        if (style.stroke) {
            if (style.constrast) {
                overlay.rectangle(this.area, {
                    width: stroke.width + 2 * style.constrast.width,
                    color: style.constrast.color
                });
            }
            const extension = style.constrast ? -style.constrast.width : 0;
            overlay.rectangle(ScreenRectangle.extend(this.area, { x: extension, y: extension }), stroke);
        }
        if (config.text && style.font) {
            overlay.text(config.text, Vector2.add(ScreenRectangle.center(this.area), { x: 1, y: -1 }), {
                ...style.font,
                centered: true
            });
        }
    }
    position() {
        return this.area;
    }
    setPosition(area) {
        this.area = area;
        this.interactivity().setBounds(area ? { type: "rectangle", area: area } : null);
        this.rerender();
    }
    updateConfig(f) {
        this.config.update2(f);
        return this;
    }
}
(function (Alt1OverlayButton) {
    function white(text = undefined) {
        return {
            text: text,
            style: {
                stroke: { width: 1, color: Alt1Color.white },
                constrast: { width: 1, color: Alt1Color.black },
                font: {
                    width: 14,
                    color: Alt1Color.white,
                    centered: true
                }
            },
            active_style: {
                stroke: { width: 2, color: Alt1Color.white },
                font: {
                    width: 14,
                    color: Alt1Color.white,
                    centered: true
                }
            }
        };
    }
    Alt1OverlayButton.white = white;
})(Alt1OverlayButton || (Alt1OverlayButton = {}));
